import { HeadleaseDetails } from "../models/headlease-details";
import { Action } from "@ngrx/store";

export const GET = '[HeadleaseDetails] Get';
export const GET_COMPLETE = '[HeadleaseDetails] Get Complete';
export const GET_ERROR = '[HeadleaseDetails] Get Error';

export class Get implements Action {
  readonly type = GET;
  constructor(public headleaseRef: number, public propertyRef: number) { }
}

export class GetComplete implements Action {
  readonly type = GET_COMPLETE;
  constructor(public payload: HeadleaseDetails) { }
}

export class GetError implements Action {
  readonly type = GET_ERROR;
  constructor(public payload: any) { }  
}

export type Actions =
  Get |
  GetComplete |
  GetError;
